// extracted by mini-css-extract-plugin
export default {"table-cell":"HOa3bUMpNofCDsn","left":"ejHn0dHNH5fKq2t","right":"c4VjsBUZYw5z4G7","center":"xoXbfeU5M71fQ6s"};